import { v4 } from '@lukeed/uuid';
import { getNameInfo } from '../utilities/getNameInfo';
export async function appendArrayBuffer(fileCollection, relativePath, arrayBuffer, options = {}) {
    const source = await getExtendedSourceFromArrayBuffer(relativePath, arrayBuffer, options);
    await fileCollection.appendExtendedSource(source);
}
async function getExtendedSourceFromArrayBuffer(originalRelativePath, arrayBuffer, options = {}) {
    const { name, relativePath } = getNameInfo(originalRelativePath);
    const blob = new Blob([await arrayBuffer], {
        type: 'application/octet-stream',
    });
    return {
        uuid: v4(),
        relativePath,
        name,
        lastModified: options.dateModified || Date.now(),
        baseURL: 'ium:/',
        text: () => blob.text(),
        stream: () => blob.stream(),
        arrayBuffer: () => blob.arrayBuffer(),
    };
}
//# sourceMappingURL=appendArrayBuffer.js.map